<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row row--primary">
  @if (model) {
    <bezugsrecht-back-link (back)="back()" label="bezugsrecht-page.bezugsrecht-buy-custom.link-back" />
  }
  @if (model?.announcement && orderForm) {
    <div class="tile">
      <form [formGroup]="orderForm">
        <div class="col-12 mt-2 opacity-container" [class.active]="model.announcement">
          <div class="row mb-2">
            <div class="col-12 mb-4">
              <h5
                [innerHTML]="
                  'bezugsrecht-page.bezugsrecht-buy-custom.title'
                    | transloco
                      : {
                          name: model.announcement.bzrBezeichnung,
                          isin: model.announcement.bzrIsin,
                        }
                "
              >
                &nbsp;
              </h5>
            </div>
            <div class="col-12 mb-2 color-text-primary font-bold">
              <div [innerHTML]="'bezugsrecht-page.bezugsrecht-buy-custom.hint' | transloco"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 align-items-center justify-content-between mb-2">
              <div
                class="input-group-material input-group-material margin-top-10"
                [class.input-group-material--error]="
                  (orderForm.get('shareAmount').touched && orderForm.get('shareAmount').invalid) ||
                  orderForm.hasError('bpTooLow') ||
                  orderForm.hasError('notEnoughQuantity')
                "
              >
                <input
                  formControlName="shareAmount"
                  id="shareAmount"
                  name="shareAmount"
                  type="text"
                  autocomplete="off"
                  inputmode="decimal"
                  data-zid="number-input"
                  class="empty"
                  [class.border-color-success]="orderForm.get('shareAmount').valid"
                  [placeholder]="'bezugsrecht-page.bezugsrecht-buy-custom.share-amount-label' | transloco"
                  [title]="'bezugsrecht-page.bezugsrecht-buy-custom.share-amount-title' | transloco"
                />
              </div>
              @if (orderForm.get('shareAmount').hasError('valueNotMultipleOfDenominator')) {
                <div
                  class="text-right mt-1 text-danger font-size-smaller2"
                  [innerHtml]="
                    'bezugsrecht-page.bezugsrecht-buy-custom.multiple-of-denominator-hint'
                      | transloco: { zaehler: (model.announcement.bezugVerhaeltnisZaehler | number) }
                  "
                ></div>
              }
              @if (orderForm.get('shareAmount').hasError('isFragment')) {
                <div
                  class="text-right mt-1 text-danger font-size-smaller2"
                  [innerHtml]="
                    'bezugsrecht-page.bezugsrecht-buy-custom.is-fragment'
                      | transloco: { zaehler: (model.announcement.bezugVerhaeltnisZaehler | number) }
                  "
                ></div>
              }
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-need' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              @if (model.directivePreview?.benoetigteBzr) {
                {{ model.directivePreview?.benoetigteBzr | number: '1.0-3' }}
              } @else {
                &mdash;
              }
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-portfolio' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">{{ model.announcement.bzrVerfuegbar | number: '1.0-3' }}</div>
          </div>
          <div class="row mt-3">
            @if (model.directivePreview?.bezugBzr) {
              <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-buy' | transloco }}</div>
              <div class="col-sm-4 font-bold text-right">
                @if (model.directivePreview?.bezugBzr) {
                  {{ model.directivePreview?.bezugBzr | number: '1.0-3' }}
                } @else {
                  &mdash;
                }
              </div>
              @if (model.announcement.bzrHandelbarBroker) {
                <div class="col-sm-12 mt-0 mb-2 font-size-smaller2">
                  {{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-buy-hint' | transloco }}
                </div>
              } @else {
                <div
                  class="col-sm-12 mt-0 mb-2 text-center font-size-smaller2"
                  [innerHTML]="'bezugsrecht-page.bezugsrecht-buy-custom.external-exchange-hint' | transloco"
                ></div>
              }
              <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-value' | transloco }}</div>
              <div class="col-sm-4 font-bold text-right">
                @if (model.directivePreview?.bezugBzrWertSumme) {
                  {{ model.directivePreview?.bezugBzrWertSumme | currency: 'EUR' : 'symbol' : '1.2' }}
                } @else {
                  &mdash;
                }
                @if (model.directivePreview?.bzrPreisZeitpunkt) {
                  <div class="font-size-smaller2">({{ model.directivePreview?.bzrPreisZeitpunkt | todayTimeOrDate }})</div>
                }
                @if (model.buyingPower) {
                  <div
                    class="text-right mt-1 font-size-smaller2"
                    [innerHtml]="
                      'bezugsrecht-page.bezugsrecht-buy-custom.buying-power-hint'
                        | transloco
                          : {
                              buyingPower: model.buyingPower | currency: 'EUR' : 'symbol' : '1.2',
                            }
                    "
                  ></div>
                }
              </div>
              @if (orderForm.get('shareAmount').hasError('bpTooLow')) {
                <div class="col-sm-12 text-right text-danger font-size-smaller2">
                  {{ 'bezugsrecht-page.bezugsrecht-buy-custom.bp-too-low-hint' | transloco }}
                </div>
              }
            } @else {
              <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-sell' | transloco }}</div>
              <div class="col-sm-4 font-bold text-right">
                @if (model.directivePreview?.verkaufBzr) {
                  {{ model.directivePreview?.verkaufBzr | number: '1.0-3' }}
                } @else {
                  &mdash;
                }
              </div>
              @if (model.announcement.bzrHandelbarBroker) {
                <div class="col-sm-12 mt-0 mb-2 font-size-smaller2">
                  {{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-sell-hint' | transloco }}
                </div>
              } @else {
                <div
                  class="col-sm-12 mt-0 mb-2 text-center font-size-smaller2"
                  [innerHTML]="'bezugsrecht-page.bezugsrecht-buy-custom.external-exchange-hint' | transloco"
                ></div>
              }
              <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.rights-value' | transloco }}</div>
              <div class="col-sm-4 font-bold text-right">
                @if (model.directivePreview?.verkaufBzrWertSumme) {
                  {{ model.directivePreview?.verkaufBzrWertSumme | currency: 'EUR' : 'symbol' : '1.2' }}
                } @else {
                  &mdash;
                }
                @if (model.directivePreview?.bzrPreisZeitpunkt) {
                  <div class="font-size-smaller2">({{ model.directivePreview?.bzrPreisZeitpunkt | todayTimeOrDate }})</div>
                }
              </div>
            }
          </div>
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.share-price' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">
              @if (model.directivePreview?.bezugAktienWertSumme) {
                {{ model.directivePreview?.bezugAktienWertSumme | currency: 'EUR' : 'symbol' : '1.2' }}
              } @else {
                &mdash;
              }
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-8">{{ 'bezugsrecht-page.bezugsrecht-buy-custom.due-date' | transloco }}</div>
            <div class="col-sm-4 font-bold text-right">{{ model.announcement.letzterHandelstag | date: 'shortDate' }}</div>
          </div>
          @if (orderForm.hasError('noActiveTradingHours')) {
            <div class="mt-2 mb-2 padding-15 text-align-center font-size-smaller1 hidden-X border-error text-danger">
              {{ 'bezugsrecht-page.bezugsrecht-buy-custom.no-active-trading-hours-hint' | transloco }}
            </div>
          }
          <div class="row mt-3">
            <div class="col-sm-12 d-flex justify-content-center">
              <web-design-system-button size="small" (click)="forward()" [disabled]="!orderForm.valid">
                {{ 'bezugsrecht-page.bezugsrecht-buy-custom.link-submit' | transloco | uppercase }}
              </web-design-system-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  }
</div>
